import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    labels: []
  },
  mutations: {
    setList(state, payload) {
      state.labels = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getLabels({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
      });
    },
    createLabel(context, query) {
      return api.createLabel(query);
    },
    removeLabel(context, query) {
      return api.removeLabel(query);
    }
  }
};

appStore.registerModule('leagueLabel', store);
